import { useMemo } from 'react';
import { InvoicePurpose } from '@insio/shared-types';
import { Select } from '../../../../components/selects/Select';
import { useTranslation } from '../../../../providers/UIProvider';
import { EditorProps } from '../types/editor-props';

/**
 * Dropdown editor for {@link InvoicePurpose}. Labels are read from the
 * `components.invoicePurpose.{value}` namespace. Picking a value commits
 * immediately, like the other simple Select-based editors.
 */
export function InvoicePurposeEditor({ id, value, onChange, onCommit, onBlur }: EditorProps) {
  const t = useTranslation('components.invoicePurpose');
  const options = useMemo(
    () =>
      Object.values(InvoicePurpose).map(purpose => ({
        value: purpose,
        label: t(purpose)
      })),
    [t]
  );

  const current = value == null ? '' : String(value);

  return (
    <Select
      id={id}
      defaultOpen
      options={options}
      value={current}
      onChange={next => {
        const picked = Array.isArray(next) ? next[0] : next;
        const code = picked == null ? '' : String(picked);
        if (onCommit) {
          void onCommit(code).catch(() => {});
        } else {
          onChange(code);
        }
      }}
      onBlur={onBlur}
      autoFocus
    />
  );
}
